import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";

import CreateXIntro from "@/views/createXIntro/Introduction.vue";
import TestingPutt from "@/views/product/testing/PUTT.vue";
import TestingTocc from "@/views/product/testing/TOCC.vue";
import TestingKat from "@/views/product/testing/KAT.vue";
import TestingPuttE from "@/views/product/testing/shop/putt/Elementary.vue";
import TestingPuttM from "@/views/product/testing/shop/putt/Middle.vue";
import TestingPuttH from "@/views/product/testing/shop/putt/High.vue";
import TestingPuttU from "@/views/product/testing/shop/putt/University.vue";
import TestingToccE from "@/views/product/testing/shop/tocc/Child.vue";
import TestingTec from "@/views/product/testing/shop/tocc/Expert.vue";
import TestingToccH from "@/views/product/testing/shop/tocc/Teen.vue";
import InstructionIndividual from "@/views/instruction/Individual.vue";
import InstructionOrg from "@/views/instruction/Org.vue";

import CoachingPutt from "@/views/product/coaching/PUTT.vue";
import CoachingTocc from "@/views/product/coaching/TOCC.vue";
import CoachingPuttE from "@/views/product/coaching/shop/putt/Elementary.vue";
import CoachingPuttM from "@/views/product/coaching/shop/putt/Middle.vue";
import CoachingPuttH from "@/views/product/coaching/shop/putt/High.vue";
import CoachingPuttU from "@/views/product/coaching/shop/putt/University.vue";
import CoachingToccE from "@/views/product/coaching/shop/tocc/Elementary.vue";
import CoachingToccM from "@/views/product/coaching/shop/tocc/Middle.vue";
import CoachingToccH from "@/views/product/coaching/shop/tocc/High.vue";
import CoachingTec from "@/views/product/coaching/shop/tocc/Expert.vue";
import Business from "@/views/business/Business.vue";
import ActivityTalent from "@/views/product/activity/Talent.vue";
import ActivityTalentE from "@/views/product/activity/shop/talent/Elementary.vue";
import ActivityTalentM from "@/views/product/activity/shop/talent/Middle.vue";
import ActivityTalentH from "@/views/product/activity/shop/talent/High.vue";
import ActivityTalentU from "@/views/product/activity/shop/talent/University.vue";

import ActivityStartup from "@/views/product/activity/Startup.vue";
import ActivityStartupE from "@/views/product/activity/shop/startup/Elementary.vue";
import ActivityStartupM from "@/views/product/activity/shop/startup/Middle.vue";
import ActivityStartupH from "@/views/product/activity/shop/startup/High.vue";

import ActivityCareer from "@/views/product/activity/Career.vue";
import ActivityCareerE from "@/views/product/activity/shop/career/Elementary.vue";
import ActivityCareerM from "@/views/product/activity/shop/career/Middle.vue";
import ActivityCareerH from "@/views/product/activity/shop/career/High.vue";
import ActivityCareerU from "@/views/product/activity/shop/career/University.vue";

import ActivityGrowth from "@/views/product/activity/Growth.vue";
import ActivityGrowthM from "@/views/product/activity/shop/growth/Middle.vue";
import ActivityGrowthH from "@/views/product/activity/shop/growth/High.vue";
import ActivityGrowthU from "@/views/product/activity/shop/growth/University.vue";

import ExpertExpert from "@/views/product/expert/Expert.vue";
import ExpertExpertE from "@/views/product/expert/shop/Elementary.vue";
import ExpertExpertH from "@/views/product/expert/shop/High.vue";
import ExpertExpertB from "@/views/product/expert/shop/Best.vue";
import ExpertExpertP from "@/views/product/expert/shop/Profesional.vue";

import ExpertCertification from "@/views/product/expert/Certification.vue";

import OrgSurveyPriceTable from "@/views/business/survey/Table.vue";
import OrgActivityPriceTable from "@/views/business/activity/Table.vue";
import OrgExpertSurveyPriceTable from "@/views/business/expert/Table.vue";
import PersonalPriceTable from "@/views/business/individual/Table.vue";

import PersonalOrderRegistration from "@/views/business/individual/Registration.vue";

import Login from "@/views/login/Login.vue";
import Join from "@/views/login/Join.vue";
import JoinRegistration from "@/views/login/Form.vue";
import JoinSuccess from "@/views/login/JoinSuccess.vue";
import MyPageModify from "@/views/member/Modify.vue";
import PersonalOrder from "@/views/member/PersonalOrder.vue";
import PersonalOrderProjectDetail from "@/views/member/PersonalOrderProjectDetail.vue";
import OrgUser from "@/views/member/OrgUser.vue";
import OrgOrder from "@/views/member/OrgOrder.vue";
import OrgOrderReq from "@/views/member/OrgOrderReq.vue";
import OrgOrderReqList from "@/views/member/OrgOrderReqList.vue";
import OrgOrderPurchaseList from "@/views/member/OrgOrderPurchaseList.vue";
import OrgOrderProject from "@/views/member/OrgOrderProject.vue";
import OrgOrderProjectDetail from "@/views/member/OrgOrderProjectDetail.vue";
import MemDelete from "@/views/member/Delete.vue";
import ReportDownload from "@/views/ReportDownload.vue";
import Survey from "@/views/Survey.vue";

import Qna from "@/views/etc/bbs/qna/List.vue";
import QnaC from "@/views/etc/bbs/qna/Content.vue";
import Notice from "@/views/etc/bbs/notice/List.vue";
import NoticeC from "@/views/etc/bbs/notice/Content.vue";
import Press from "@/views/etc/bbs/press/List.vue";
import PressC from "@/views/etc/bbs/press/Content.vue";
import Inquiry from "@/views/etc/bbs/inquiry/Form.vue";
import OrgInquiry from "@/views/etc/bbs/inquiry/OrgForm.vue";

import AboutIntroduce from "@/views/etc/page/Sub1.vue";
import Profile from "@/views/etc/page/Sub2.vue";
import Philosophy from "@/views/etc/page/Sub3.vue";
import Vision from "@/views/etc/page/Sub4.vue";
import OrgChart from "@/views/etc/page/Sub5.vue";
import Map from "@/views/etc/page/Sub6.vue";

import Privacy from "@/views/etc/privacy/Privacy.vue";

import RequestOrgRegist from "@/views/login/RequestOrgRegist.vue";

import { USER_ROUTES } from "@/assets/route_constants";

import Root from "@/views/Root.vue";
import Home from "@/views/home/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: USER_ROUTES.Root.Path,
    name: USER_ROUTES.Root.Name,
    component: Root,
    children: [
      {
        path: USER_ROUTES.Home.Path,
        name: USER_ROUTES.Home.Name,
        component: Home,
        meta: { title: "COKOLab. Inc." },
      },
      {
        path: USER_ROUTES.Intro.Path,
        name: USER_ROUTES.Intro.Name,
        component: CreateXIntro,
        meta: { title: "COKOLab. Inc. Createx 란" },
      },
      {
        path: USER_ROUTES.Instruction.individual.Path,
        name: USER_ROUTES.Instruction.individual.Name,
        component: InstructionIndividual,
        meta: { title: "COKOLab. Inc. 개인 이용안내" },
      },
      {
        path: USER_ROUTES.Instruction.org.Path,
        name: USER_ROUTES.Instruction.org.Name,
        component: InstructionOrg,
        meta: { title: "COKOLab. Inc. 기관 이용안내" },
      },
      {
        path: USER_ROUTES.Product.Testing.Putt.Path,
        name: USER_ROUTES.Product.Testing.Putt.Name,
        component: TestingPutt,
        meta: { title: "COKOLab. Inc. PUTT2.0 다중재능검사" },
      },
      {
        path: USER_ROUTES.Product.Testing.Putt.Path,
        name: USER_ROUTES.Product.Testing.Putt.Name,
        component: TestingPutt,
        meta: { title: "COKOLab. Inc. PUTT2.0 다중재능검사" },
      },
      {
        path: USER_ROUTES.Product.Testing.Tocc.Path,
        name: USER_ROUTES.Product.Testing.Tocc.Name,
        component: TestingTocc,
        meta: { title: "COKOLab. Inc. TOCC창의력검사" },
      },
      {
        path: USER_ROUTES.Product.Testing.Kat.Path,
        name: USER_ROUTES.Product.Testing.Kat.Name,
        component: TestingKat,
        meta: { title: "COKOLab. Inc. KAT" },
      },
      {
        path: USER_ROUTES.Product.Testing.Putt.Putt_e.Path,
        name: USER_ROUTES.Product.Testing.Putt.Putt_e.Name,
        component: TestingPuttE,
        meta: { title: "COKOLab. Inc. PUTT2.0 다중재능검사" },
      },
      {
        path: USER_ROUTES.Product.Testing.Putt.Putt_m.Path,
        name: USER_ROUTES.Product.Testing.Putt.Putt_m.Name,
        component: TestingPuttM,
        meta: { title: "COKOLab. Inc. PUTT2.0 다중재능검사" },
      },
      {
        path: USER_ROUTES.Product.Testing.Putt.Putt_h.Path,
        name: USER_ROUTES.Product.Testing.Putt.Putt_h.Name,
        component: TestingPuttH,
        meta: { title: "COKOLab. Inc. PUTT2.0 다중재능검사" },
      },
      {
        path: USER_ROUTES.Product.Testing.Putt.Putt_u.Path,
        name: USER_ROUTES.Product.Testing.Putt.Putt_u.Name,
        component: TestingPuttU,
        meta: { title: "COKOLab. Inc. PUTT2.0 다중재능검사" },
      },
      {
        path: USER_ROUTES.Product.Testing.Tocc.Tocc_e.Path,
        name: USER_ROUTES.Product.Testing.Tocc.Tocc_e.Name,
        component: TestingToccE,
        meta: { title: "COKOLab. Inc. TOCC창의력검사" },
      },
      {
        path: USER_ROUTES.Product.Testing.Tocc.Tocc_h.Path,
        name: USER_ROUTES.Product.Testing.Tocc.Tocc_h.Name,
        component: TestingToccH,
        meta: { title: "COKOLab. Inc. TOCC창의력검사" },
      },
      {
        path: USER_ROUTES.Product.Testing.Tocc.Tec.Path,
        name: USER_ROUTES.Product.Testing.Tocc.Tec.Name,
        component: TestingTec,
        meta: { title: "COKOLab. Inc. TOCC창의력검사" },
      },

      {
        path: USER_ROUTES.Product.Coaching.Putt.Path,
        name: USER_ROUTES.Product.Coaching.Putt.Name,
        component: CoachingPutt,
        meta: { title: "COKOLab. Inc. putt_학습진로 상담코칭" },
      },
      {
        path: USER_ROUTES.Product.Coaching.Tocc.Path,
        name: USER_ROUTES.Product.Coaching.Tocc.Name,
        component: CoachingTocc,
        meta: { title: "COKOLab. Inc. tocc_학습진로 상담코칭" },
      },
      {
        path: USER_ROUTES.Product.Coaching.Putt.Putt_e.Path,
        name: USER_ROUTES.Product.Coaching.Putt.Putt_e.Name,
        component: CoachingPuttE,
        meta: { title: "COKOLab. Inc. putt_학습진로 상담코칭" },
      },
      {
        path: USER_ROUTES.Product.Coaching.Putt.Putt_m.Path,
        name: USER_ROUTES.Product.Coaching.Putt.Putt_m.Name,
        component: CoachingPuttM,
        meta: { title: "COKOLab. Inc. putt_학습진로 상담코칭" },
      },
      {
        path: USER_ROUTES.Product.Coaching.Putt.Putt_h.Path,
        name: USER_ROUTES.Product.Coaching.Putt.Putt_h.Name,
        component: CoachingPuttH,
        meta: { title: "COKOLab. Inc. putt_학습진로 상담코칭" },
      },
      {
        path: USER_ROUTES.Product.Coaching.Putt.Putt_u.Path,
        name: USER_ROUTES.Product.Coaching.Putt.Putt_u.Name,
        component: CoachingPuttU,
        meta: { title: "COKOLab. Inc. putt_학습진로 상담코칭" },
      },
      {
        path: USER_ROUTES.Product.Coaching.Tocc.Tocc_e.Path,
        name: "ShopTocc3",
        component: CoachingToccE,
        meta: { title: "COKOLab. Inc. tocc_학습진로 상담코칭" },
      },
      {
        path: USER_ROUTES.Product.Coaching.Tocc.Tocc_m.Path,
        name: USER_ROUTES.Product.Coaching.Tocc.Tocc_m.Name,
        component: CoachingToccM,
        meta: { title: "COKOLab. Inc. tocc_학습진로 상담코칭" },
      },
      {
        path: USER_ROUTES.Product.Coaching.Tocc.Tocc_h.Path,
        name: USER_ROUTES.Product.Coaching.Tocc.Tocc_h.Name,
        component: CoachingToccH,
        meta: { title: "COKOLab. Inc. tocc_학습진로 상담코칭" },
      },
      {
        path: USER_ROUTES.Product.Coaching.Tocc.Tec.Path,
        name: USER_ROUTES.Product.Coaching.Tocc.Tec.Name,
        component: CoachingTec,
        meta: { title: "COKOLab. Inc. tocc_학습진로 상담코칭" },
      },

      {
        path: USER_ROUTES.Product.Activity.Talent.Path,
        name: USER_ROUTES.Product.Activity.Talent.Name,
        component: ActivityTalent,
        meta: { title: "COKOLab. Inc. 재능진로전공직업 탐색 프로젝트" },
      },
      {
        path: USER_ROUTES.Product.Activity.Talent.Talent_e.Path,
        name: USER_ROUTES.Product.Activity.Talent.Talent_e.Name,
        component: ActivityTalentE,
        meta: { title: "COKOLab. Inc. 재능진로전공직업 탐색 프로젝트" },
      },
      {
        path: USER_ROUTES.Product.Activity.Talent.Talent_m.Path,
        name: USER_ROUTES.Product.Activity.Talent.Talent_m.Name,
        component: ActivityTalentM,
        meta: { title: "COKOLab. Inc. 재능진로전공직업 탐색 프로젝트" },
      },
      {
        path: USER_ROUTES.Product.Activity.Talent.Talent_h.Path,
        name: USER_ROUTES.Product.Activity.Talent.Talent_h.Name,
        component: ActivityTalentH,
        meta: { title: "COKOLab. Inc. 재능진로전공직업 탐색 프로젝트" },
      },
      {
        path: USER_ROUTES.Product.Activity.Talent.Talent_u.Path,
        name: USER_ROUTES.Product.Activity.Talent.Talent_u.Name,
        component: ActivityTalentU,
        meta: { title: "COKOLab. Inc. 재능진로전공직업 탐색 프로젝트" },
      },

      {
        path: USER_ROUTES.Product.Activity.Startup.Path,
        name: USER_ROUTES.Product.Activity.Startup.Name,
        component: ActivityStartup,
        meta: { title: "COKOLab. Inc. 꿈 창업 프로젝트" },
      },
      {
        path: USER_ROUTES.Product.Activity.Startup.Startup_e.Path,
        name: USER_ROUTES.Product.Activity.Startup.Startup_e.Name,
        component: ActivityStartupE,
        meta: { title: "COKOLab. Inc. 꿈 창업 프로젝트" },
      },
      {
        path: USER_ROUTES.Product.Activity.Startup.Startup_m.Path,
        name: USER_ROUTES.Product.Activity.Startup.Startup_m.Name,
        component: ActivityStartupM,
        meta: { title: "COKOLab. Inc. 꿈 창업 프로젝트" },
      },
      {
        path: USER_ROUTES.Product.Activity.Startup.Startup_h.Path,
        name: USER_ROUTES.Product.Activity.Startup.Startup_h.Name,
        component: ActivityStartupH,
        meta: { title: "COKOLab. Inc. 꿈 창업 프로젝트" },
      },

      {
        path: USER_ROUTES.Product.Activity.Career.Path,
        name: USER_ROUTES.Product.Activity.Career.Name,
        component: ActivityCareer,
        meta: { title: "COKOLab. Inc. 데이터 사이언스 체험 활동" },
      },
      {
        path: USER_ROUTES.Product.Activity.Career.Career_e.Path,
        name: USER_ROUTES.Product.Activity.Career.Career_e.Name,
        component: ActivityCareerE,
        meta: { title: "COKOLab. Inc. 데이터 사이언스 체험 활동" },
      },
      {
        path: USER_ROUTES.Product.Activity.Career.Career_m.Path,
        name: USER_ROUTES.Product.Activity.Career.Career_m.Name,
        component: ActivityCareerM,
        meta: { title: "COKOLab. Inc. 데이터 사이언스 체험 활동" },
      },
      {
        path: USER_ROUTES.Product.Activity.Career.Career_h.Path,
        name: USER_ROUTES.Product.Activity.Career.Career_h.Name,
        component: ActivityCareerH,
        meta: { title: "COKOLab. Inc. 데이터 사이언스 체험 활동" },
      },
      {
        path: USER_ROUTES.Product.Activity.Career.Career_u.Path,
        name: USER_ROUTES.Product.Activity.Career.Career_u.Name,
        component: ActivityCareerU,
        meta: { title: "COKOLab. Inc. 데이터 사이언스 체험 활동" },
      },

      {
        path: USER_ROUTES.Product.Activity.Growth.Path,
        name: USER_ROUTES.Product.Activity.Growth.Name,
        component: ActivityGrowth,
        meta: { title: "COKOLab. Inc. 성장-폴리오 과정" },
      },
      {
        path: USER_ROUTES.Product.Activity.Growth.Growth_e.Path,
        name: USER_ROUTES.Product.Activity.Growth.Growth_e.Name,
        component: ActivityGrowthM,
        meta: { title: "COKOLab. Inc. 성장-폴리오 과정" },
      },
      {
        path: USER_ROUTES.Product.Activity.Growth.Growth_m.Path,
        name: USER_ROUTES.Product.Activity.Growth.Growth_m.Name,
        component: ActivityGrowthH,
        meta: { title: "COKOLab. Inc. 성장-폴리오 과정" },
      },
      {
        path: USER_ROUTES.Product.Activity.Growth.Growth_h.Path,
        name: USER_ROUTES.Product.Activity.Growth.Growth_h.Name,
        component: ActivityGrowthU,
        meta: { title: "COKOLab. Inc. 성장-폴리오 과정" },
      },

      {
        path: USER_ROUTES.Product.Expert.Expert.Path,
        name: USER_ROUTES.Product.Expert.Expert.Name,
        component: ExpertExpert,
        meta: { title: "COKOLab. Inc. 전문가 과정" },
      },
      {
        path: USER_ROUTES.Product.Expert.Expert.Expert_e.Path,
        name: USER_ROUTES.Product.Expert.Expert.Expert_e.Name,
        component: ExpertExpertE,
        meta: { title: "COKOLab. Inc. 전문가 과정" },
      },
      {
        path: USER_ROUTES.Product.Expert.Expert.Expert_h.Path,
        name: USER_ROUTES.Product.Expert.Expert.Expert_h.Name,
        component: ExpertExpertH,
        meta: { title: "COKOLab. Inc. 전문가 과정" },
      },
      {
        path: USER_ROUTES.Product.Expert.Expert.Expert_b.Path,
        name: USER_ROUTES.Product.Expert.Expert.Expert_b.Name,
        component: ExpertExpertB,
        meta: { title: "COKOLab. Inc. 전문가 과정" },
      },
      {
        path: USER_ROUTES.Product.Expert.Expert.Expert_p.Path,
        name: USER_ROUTES.Product.Expert.Expert.Expert_p.Name,
        component: ExpertExpertP,
        meta: { title: "COKOLab. Inc. 전문가 과정" },
      },

      {
        path: USER_ROUTES.Product.Expert.Cert.Path,
        name: USER_ROUTES.Product.Expert.Cert.Name,
        component: ExpertCertification,
        meta: { title: "COKOLab. Inc. 자격증관리" },
      },

      {
        path: USER_ROUTES.Price.Org.Path,
        name: USER_ROUTES.Price.Org.Name,
        component: Business,
        meta: { title: "COKOLab. Inc. 기관 예약 및 주문하기" },
      },
      {
        path: USER_ROUTES.Price.Org.Test.Path,
        name: USER_ROUTES.Price.Org.Test.Name,
        component: OrgSurveyPriceTable,
        meta: {
          title: "COKOLab. Inc. [기관] 검사 및 상담 코칭 소요시간· 가격",
        },
      },
      {
        path: USER_ROUTES.Price.Org.Activity.Path,
        name: USER_ROUTES.Price.Org.Activity.Name,
        component: OrgActivityPriceTable,
        meta: { title: "COKOLab. Inc. [기관] Activity 시수 및 가격" },
      },
      {
        path: USER_ROUTES.Price.Org.Expert.Path,
        name: USER_ROUTES.Price.Org.Expert.Name,
        component: OrgExpertSurveyPriceTable,
        meta: {
          title:
            "COKOLab. Inc. 다중재능코칭 및 성장-폴리오 전문가 교육 진단가격",
        },
      },
      {
        path: USER_ROUTES.Price.Personal.Path,
        name: USER_ROUTES.Price.Personal.Name,
        component: PersonalPriceTable,
        meta: {
          title:
            "COKOLab. Inc. [개인] 검사 및 상담 코칭 소요시간· 가격· 구매· 상담신청",
        },
      },
      {
        path: USER_ROUTES.Offer.Personal.Path,
        name: USER_ROUTES.Offer.Personal.Name,
        component: PersonalOrderRegistration,
        meta: {
          title:
            "COKOLab. Inc. [개인] 검사 및 상담 코칭 소요시간· 가격· 구매· 상담신청",
        },
      },

      {
        path: USER_ROUTES.Qna.Path,
        name: USER_ROUTES.Qna.Name,
        component: Qna,
        meta: { title: "COKOLab. Inc. FAQ" },
      },
      {
        path: USER_ROUTES.Qna.Content.Path,
        name: USER_ROUTES.Qna.Content.Name,
        component: QnaC,
        meta: { title: "COKOLab. Inc. FAQ" },
      },
      {
        path: USER_ROUTES.Notice.Path,
        name: USER_ROUTES.Notice.Name,
        component: Notice,
        meta: { title: "COKOLab. Inc. 공지사항" },
      },
      {
        path: USER_ROUTES.Notice.Content.Path,
        name: USER_ROUTES.Notice.Content.Name,
        component: NoticeC,
        meta: { title: "COKOLab. Inc. 공지사항" },
      },
      {
        path: USER_ROUTES.Press.Path,
        name: USER_ROUTES.Press.Name,
        component: Press,
        meta: { title: "COKOLab. Inc. 홍보자료실" },
      },
      {
        path: USER_ROUTES.Press.Content.Path,
        name: USER_ROUTES.Press.Content.Name,
        component: PressC,
        meta: { title: "COKOLab. Inc. 홍보자료실" },
      },
      {
        path: USER_ROUTES.Inquiry.Path,
        name: USER_ROUTES.Inquiry.Name,
        component: Inquiry,
        meta: { title: "COKOLab. Inc. 문의하기" },
      },
      {
        path: USER_ROUTES.OrgInquiry.Path,
        name: USER_ROUTES.OrgInquiry.Name,
        component: OrgInquiry,
        meta: { title: "COKOLab. Inc. 문의하기(기관)" },
      },
      {
        path: USER_ROUTES.About.Path,
        name: USER_ROUTES.About.Name,
        component: AboutIntroduce,
        meta: { title: "COKOLab. Inc. 인사말씀" },
      },
      {
        path: USER_ROUTES.About.Profile.Path,
        name: USER_ROUTES.About.Profile.Name,
        component: Profile,
        meta: { title: "COKOLab. Inc. 대표이사 프로필" },
      },
      {
        path: USER_ROUTES.About.Philosophy.Path,
        name: USER_ROUTES.About.Philosophy.Name,
        component: Philosophy,
        meta: { title: "COKOLab. Inc. 철학" },
      },
      {
        path: USER_ROUTES.About.Vision.Path,
        name: USER_ROUTES.About.Vision.Name,
        component: Vision,
        meta: { title: "COKOLab. Inc. 비전과 미전" },
      },
      {
        path: USER_ROUTES.About.OrgChart.Path,
        name: USER_ROUTES.About.OrgChart.Name,
        component: OrgChart,
        meta: { title: "COKOLab. Inc. 조직도" },
      },
      {
        path: USER_ROUTES.About.Map.Path,
        name: USER_ROUTES.About.Map.Name,
        component: Map,
        meta: { title: "COKOLab. Inc. 오시는 길" },
      },

      {
        path: USER_ROUTES.Privacy.Path,
        name: USER_ROUTES.Privacy.Name,
        component: Privacy,
      },

      {
        path: USER_ROUTES.Login.Path,
        name: USER_ROUTES.Login.Name,
        component: Login,
      },
      {
        path: USER_ROUTES.Join.Path,
        name: USER_ROUTES.Join.Name,
        component: Join,
      },
      {
        path: USER_ROUTES.Join.Registration.Path,
        name: USER_ROUTES.Join.Registration.Name,
        component: JoinRegistration,
      },
      {
        path: USER_ROUTES.Join.Success.Path,
        name: USER_ROUTES.Join.Success.Name,
        component: JoinSuccess,
      },
      {
        path: USER_ROUTES.Mypage.Modify.Path,
        name: USER_ROUTES.Mypage.Modify.Name,
        component: MyPageModify,
        meta: { requiresAuth: true },
      },
      {
        path: USER_ROUTES.Mypage.Order.Personal.Path,
        name: USER_ROUTES.Mypage.Order.Personal.Name,
        component: PersonalOrder,
        meta: { requiresAuth: true },
      },
      {
        path: USER_ROUTES.Mypage.Order.Personal.Detail.Path,
        name: USER_ROUTES.Mypage.Order.Personal.Detail.Name,
        component: PersonalOrderProjectDetail,
      },
      {
        path: USER_ROUTES.Mypage.Order.Org.Path,
        name: USER_ROUTES.Mypage.Order.Org.Name,
        component: OrgOrder,
        meta: { requiresAuth: true },
      },
      {
        path: USER_ROUTES.Mypage.Order.Org.Request.Path,
        name: USER_ROUTES.Mypage.Order.Org.Request.Name,
        component: OrgOrderReq,
        meta: { requiresAuth: true },
      },
      {
        path: USER_ROUTES.Mypage.Order.Org.RequestList.Path,
        name: USER_ROUTES.Mypage.Order.Org.RequestList.Name,
        component: OrgOrderReqList,
        meta: { requiresAuth: true },
      },
      {
        path: USER_ROUTES.Mypage.Order.Org.PurchaseList.Path,
        name: USER_ROUTES.Mypage.Order.Org.PurchaseList.Name,
        component: OrgOrderPurchaseList,
        meta: { requiresAuth: true },
      },
      {
        path: USER_ROUTES.Mypage.Order.Org.Project.Path,
        name: USER_ROUTES.Mypage.Order.Org.Project.Name,
        component: OrgOrderProject,
      },
      {
        path: USER_ROUTES.Mypage.Order.Org.Project.Detail.Path,
        name: USER_ROUTES.Mypage.Order.Org.Project.Detail.Name,
        component: OrgOrderProjectDetail,
      },
      {
        path: USER_ROUTES.Mypage.User.Org.Path,
        name: USER_ROUTES.Mypage.User.Org.Name,
        component: OrgUser,
      },
      {
        path: USER_ROUTES.RequestOrgRegist.Path,
        name: USER_ROUTES.RequestOrgRegist.Name,
        component: RequestOrgRegist,
      },
      // { path: USER_ROUTES.MEMMODIFY, name: "MemberModify", component: MyPageModify },
      // { path: USER_ROUTES.MEMDELETE, name: "MemberDelete", component: MemDelete },
    ],
  },
  {
    path: USER_ROUTES.ReportDownload.Path,
    name: USER_ROUTES.ReportDownload.Name,
    component: ReportDownload,
  },
  {
    path: USER_ROUTES.Survey.Path,
    name: USER_ROUTES.Survey.Name,
    component: Survey,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 };
  },
});

// router.beforeEach((to, from, next) => {
//     const isAuthenticated = store.state.isLoggedIn;
//     console.log("to.meta.requiresAuth : ", to.meta.requiresAuth, ", isAuthenticated : ", isAuthenticated);
//     if (to.meta.requiresAuth && !isAuthenticated) {
//         next(USER_ROUTES.Login.Path);
//     } else {
//         next();
//     }
// });

export default router;
